export const debounce = (callback, wait) => {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

export const replaceAll = (string, search, replace) => {
  return string.split(search).join(replace)
}

export const cleanRedirectUrl = (url) =>
  url.substring(0, 6) === '/blog/' ? url.substring(5) : url

export const trimString = (str, limit = 120) => {
  // If the string is already shorter than or equal to limit characters, return it as is
  if (str.length <= limit) {
    return str
  }

  // Otherwise, find the last space character before the limit character
  let trimIndex = limit
  while (trimIndex > 0 && str.charAt(trimIndex) !== ' ') {
    trimIndex--
  }

  // If no space character is found, the string will be trimmed at the limit character
  // Otherwise, it will be trimmed at the last space character found
  return str.substring(0, trimIndex > 0 ? trimIndex : limit)
}
